import { DatePicker, Select } from 'antd'
import CustomButton from 'components/ui/custom-button'
import FormInput from 'components/ui/form/form-input'
import FormSelect from 'components/ui/form/form-select'
import InputCurrency from 'components/ui/input-currency'
import { ModalLayout } from 'layouts'
import React from 'react'

const ModalFilterCatalog = ({
  openModal,
  onCancel,
  filter,
  handleFilter,
  locations,
  fuels,
  transmissions,
  models,
  colors,
  types,
  brands,
  handleResetFilter,
  provinces,
  cities
}) => {
  const informasiMobilInput = [
    {
      id: 1,
      label: 'Merek',
      name: 'merek',
      type: 'select',
      options: brands,
      placeholder: 'Pilih Merek',
      value: filter?.merek?.label
    },
    {
      id: 2,
      label: 'Model',
      name: 'model',
      type: 'select',
      options: models,
      placeholder: 'Pilih Model',
      value: filter.model?.label
    },
    {
      id: 3,
      label: 'Tipe',
      name: 'tipe',
      type: 'select',
      options: types,
      placeholder: 'Pilih Tipe',
      value: filter.tipe?.label
    },
    {
      id: 4,
      label: 'Transmisi',
      name: 'transmisi',
      type: 'select',
      options: transmissions,
      placeholder: 'Pilih Transmisi',
      value: filter.transmisi?.label
    },
    {
      id: 6,
      label: 'Bahan Bakar',
      name: 'bahanBakar',
      type: 'select',
      options: fuels,
      placeholder: 'Pilih Bahan Bakar',
      value: filter.bahanBakar?.label
    },
    {
      id: 7,
      label: 'Warna',
      name: 'warna',
      type: 'select',
      options: colors,
      placeholder: 'Pilih Warna',
      value: filter.warna?.label
    }
  ]
  return (
    <ModalLayout
      className={'max-w-md w-full md:hidden'}
      openModal={openModal}
      onCancel={onCancel}
      headerTitle={'Filter'}>
      <div className="grid grid-cols-1 gap-3">
        <p className="text-gray-700 text-lg-medium">Informasi Mobil</p>
        <div className="grid grid-cols-1 gap-2">
          <p className="text-sm-medium text-gray-700">Provinsi</p>
          <Select
            onChange={(value, option) =>
              handleFilter('province', { label: option.label, value: option.value })
            }
            options={provinces}
            value={filter?.province}
            defaultValue={'Pilih Provinsi'}
            placeholder="Pilih Provinsi"
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </div>
        <div className="grid grid-cols-1 gap-2">
          <p className="text-sm-medium text-gray-700">Kota</p>
          <Select
            onChange={(value, option) =>
              handleFilter('city', { label: option.label, value: option.value })
            }
            options={cities}
            value={filter?.city}
            defaultValue={'Pilih Kota'}
            placeholder="Pilih Kota"
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </div>
        <div className="grid grid-cols-1 gap-2">
          <p className="text-sm-medium text-gray-700">Cabang</p>
          <Select
            onChange={(value, option) =>
              handleFilter('location', { label: option.label, value: option.value })
            }
            options={locations}
            value={filter?.location}
            defaultValue={'Pilih Cabang'}
            placeholder="Pilih Cabang"
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </div>
        <div className="grid grid-cols-1 gap-3">
          <p className="text-gray-700 text-lg-medium">Informasi Mobil</p>
          {informasiMobilInput.map((data, index) => (
            <FormSelect
              key={index}
              data={{ ...data, onChange: (value, option) => handleFilter(data.name, option) }}
            />
          ))}
        </div>
        <div className="grid grid-cols-1 gap-3">
          <p className="text-gray-700 text-lg-medium">Tahun Keluaran</p>
          <div className="grid grid-cols-2 gap-3">
            <div className="flex flex-col gap-2">
              <p className="text-sm-medium text-gray-700">Dari</p>
              <DatePicker
                onChange={(_, dateString) => handleFilter('minTahun', dateString)}
                picker="year"
              />
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-sm-medium text-gray-700">Hingga</p>
              <DatePicker
                onChange={(_, dateString) => handleFilter('maxTahun', dateString)}
                picker="year"
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-3">
          <p className="text-gray-700 text-lg-medium">Jarak Tempuh</p>
          <div className="grid grid-cols-2 gap-3">
            <FormInput
              data={{
                label: 'Dari',
                type: 'number',
                pattern: '[0-9]*',
                placeholder: '0',
                value: filter?.minTempuh,
                name: 'minTempuh',
                onChange: (e) => handleFilter(e.target.name, e.target.value),
                suffix: 'KM'
              }}
            />
            <FormInput
              data={{
                pattern: '[0-9]*',
                label: 'Hingga',
                type: 'number',
                name: 'maxTempuh',
                placeholder: '1000',
                value: filter?.maxTempuh,
                onChange: (e) => handleFilter(e.target.name, e.target.value),
                suffix: 'KM'
              }}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-3">
          <p className="text-gray-700 text-lg-medium">Harga</p>
          <div className="grid grid-cols-1 gap-2">
            <p className="text-sm-medium text-gray-700">Minimum</p>
            <InputCurrency
              placeholder="Rp 2000000"
              value={filter?.minHarga ? filter?.minHarga : ''}
              onChange={(value, name) => handleFilter(name, value)}
              name="minHarga"
              prefix="Rp"
            />
          </div>
          <div className="grid grid-cols-1 gap-2">
            <p className="text-sm-medium text-gray-700">Maximum</p>
            <InputCurrency
              placeholder="Rp 2000000"
              value={filter?.maxHarga ? filter?.maxHarga : ''}
              onChange={(value, name) => handleFilter(name, value)}
              name="maxHarga"
              prefix="Rp"
            />
          </div>
        </div>
        <div className="flex justify-end items-center gap-2">
          <CustomButton
            type="plain"
            onClick={() => {
              handleResetFilter()
              onCancel()
            }}
            label={'Reset Filter'}
          />
          <CustomButton onClick={onCancel} label={'Simpan Filter'} />
        </div>
      </div>
    </ModalLayout>
  )
}

export default ModalFilterCatalog
